import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import IconCheckSmall from '@adv-mt/mt-svg-icons/lib/CheckSmall.js'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'
import {Badge, BADGE_DESIGNS, BADGE_INTENTS, BADGE_SIZES} from '@adv-mt/ui/badge'
import {Button, BUTTON_SHAPES, BUTTON_SIZES, BUTTON_VARIANTS} from '@adv-mt/ui/button'
import {Icon, ICON_INTENTS, ICON_SIZES} from '@adv-mt/ui/icon'
import {Body1, Subhead1} from '@adv-mt/ui/typography'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../../config.js'
import {DRAWER_TYPES} from '../../../drawers/config.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-certification`
const MAX_FEATURES_DISPLAYED = 4

const Certification = ({onOpenDrawer, vehicleCertification = {}}) => {
  const {domain, i18n} = useSuiContext()
  const {track: analyticsTrack} = useAnalyticsTrack()
  const {features = [], logoUrl, make} = vehicleCertification

  const {TRACKING_EVENT_NAMES} = domain.get('config').get('tracking')

  const isHigherThanMobile = useMediaQuery(useMediaQueryBreakpoints.sm, {
    defaultMatches: !domain.get('config').get('isMobile')
  })

  const handleShowAllBenefits = () => {
    onOpenDrawer({data: features, type: DRAWER_TYPES.CERTIFICATION})
    analyticsTrack({event: TRACKING_EVENT_NAMES.MANUFACTURER_CERTIFIED_CLICKED})
  }

  return (
    <div className={BASE_CLASS}>
      <div className={`${BASE_CLASS}-header`}>
        <Badge design={BADGE_DESIGNS.SOFT} intent={BADGE_INTENTS.SUCCESS} size={BADGE_SIZES.MEDIUM}>
          {i18n.t('COMMON_CERTIFIED')}
        </Badge>
        <Subhead1 as="h3">{i18n.t('COMMON.DETAIL_CERTIFICATION_SUBTITLE', {make})}</Subhead1>
      </div>

      {Boolean(logoUrl) && <img alt="" className={`${BASE_CLASS}-logo`} src={logoUrl} />}

      <ul className={`${BASE_CLASS}-list`}>
        {features.slice(0, MAX_FEATURES_DISPLAYED).map(({title}) => (
          <li className={`${BASE_CLASS}-item`} key={title}>
            <Icon size={ICON_SIZES.MD} intent={ICON_INTENTS.PRIMARY}>
              <IconCheckSmall size={ICON_SIZES.MD} />
            </Icon>
            <Body1>{title}</Body1>
          </li>
        ))}
      </ul>

      <div className={`${BASE_CLASS}-actions`}>
        <Button
          onClick={handleShowAllBenefits}
          shape={BUTTON_SHAPES.CIRCLE}
          size={isHigherThanMobile ? BUTTON_SIZES.MEDIUM : BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.OUTLINE}
        >
          {i18n.t('COMMON.DETAIL_CERTIFICATION_SHOW_ALL_BENEFITS')}
        </Button>
      </div>
    </div>
  )
}

Certification.displayName = 'Certification'

Certification.propTypes = {
  onOpenDrawer: PropTypes.func.isRequired,
  vehicleCertification: PropTypes.shape({
    features: PropTypes.arrayOf(
      PropTypes.shape({
        description: PropTypes.string,
        title: PropTypes.string
      })
    ),
    logoUrl: PropTypes.string,
    make: PropTypes.string
  })
}

export default Certification
